export const VIEW_BUNDLES = "View Bundles";
export const CREATE_BUNDLES = "Create Bundles";
export const SHARE_BUNDLES = "Share Bundles";
export const EDIT_BUNDLES = "Edit Bundles";

export const PRICING_LIST_PLANS = "Pricing List Plans";
export const PRICING_ADD_PLAN = "Pricing Add Plan";
export const PRICING_EDIT_PLAN = "Pricing Edit Plan";
export const PRICING_SHARE_PLAN = "Pricing Share Plan";
export const RETIRED_PRICING_PLANS = "Retired Pricing Plans";
export const BUNDLE_DOCS = "Bundle Docs";
export const BUNDLE_PRICE_PLAN_HISTORY = "Bundle Price Plan History";

export const ADD_A_PLAN = "Add a Plan";
export const CREATE_A_CONTAINER = "Create a Container";
